import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';

@Component({
    components: {

    },
    // 过滤器 格式化金额
    filters: {
      Money(data: number) {
        return typeof(data) === 'number' ? '-' + data.toFixed(2) : data;
      },
      Balance(data: number) {
        return data + ' 元';
      },
    },
})
export default class SpendDetails extends Vue {
  private $api: any;
  private spendlist: any = [];
  private loading = false;
  private pageIndex = 1;
  private status = 0; // 0 正常, 1 数据全部加载, 2 加载失败
  private scrollView: any = null; // 记录被滚动的元素
  private spendDate: any = '';    // 消费日期
  private balance: number = 0;    // 余额

  // 时间选择器
  private show: boolean = false;
  private minDate: any = new Date(2019, 1);
  private currentDate: any = new Date();

  // 获取余额
  private async getBalance() {
    const result = await this.$api.httpGet('Salary/SupermarketRecharge/GetUserBalance');
    if (result.Success) {
      this.balance = result.Data.UserBalance;
    }
  }

  // 获取消费记录列表
  private async getSpendList() {
    this.loading = true;  // 显示加载中字样
    this.status = 0;      // 隐藏"没有更多了"，"获取失败"字样

    const params = {
      // 分页
      paging: {
        pageIndex: this.pageIndex,  // 索引
        pageSize: 10,   // 长度
      },
      // 查询条件
      entity: {
        ConsumptionDate: this.spendDate,  // 月份
      },
    };
    const result = await this.$api.httpPost('Salary/SupermarketRecharge/QueryUserConsumeRecord', params);
    if (result.Success) {
      // console.log(result.Data);
      // this.rechargelist = result.Data;
      if (result.Data.length !== 0) {

        for (const item of result.Data) {
          this.spendlist.push(item);
        }

        this.status = 0;
      } else {
        this.status = 1;
        this.pageIndex = this.pageIndex - 1;
      }
    } else {
      this.status = 2;
      this.pageIndex = this.pageIndex - 1;
    }
    this.endLoading();
  }

  // 监听滑动到底部
  private onScroll(event: any) {
    this.scrollView = event.target;
    const scrollTop = this.scrollView.scrollTop;
    const clientHeight = this.scrollView.clientHeight;
    const scrollHeight = this.scrollView.scrollHeight;
    // 算法：scrollTop + clientHeight >= scrollHeight
    // 有时候拉到底却不触发事件，为了确保会触发，条件里减去1
    if (scrollTop + clientHeight >= scrollHeight - 1) {
      this.loadNextPage();
    }
  }

  // 加载下一页
  private async loadNextPage() {
    if (this.loading) {
      return;
    }
    
    this.pageIndex = this.pageIndex + 1;
    // console.log(this.pageIndex);

    this.getSpendList();
  }

  // 上拉加载结束
  private endLoading() {
    this.loading = false;
    // 回滚 (用于解决无限触发滚动事件的bug)
    if (!this.scrollView) {
      return;
    }
    this.scrollView.scrollTop = this.scrollView.scrollTop - 10;
    // console.log(this.scrollView.scrollTop);
  }


  // 格式化时间
  private formatter(type: string, value: string) {
    if (type === 'year') {
      return `${value}年`;
    } else if (type === 'month') {
      return `${value}月`;
    }
    return value;
  }

  // 弹出时间选择器
  private pickDate() {
    this.show = true;
  }

  private changeDate(value: string) {
    this.spendDate = moment(value).format('YYYY-MM-DD');
    this.cancel();
    this.pageIndex = 1;        // 重置页数索引
    this.spendlist.length = 0; // 清空当前列表
    this.getSpendList();
  }

  // 取消弹窗
  private cancel() {
    this.show = false;
  }

  private clearDate(event: any) {
    // console.log(event);
    event.stopPropagation(); // 阻止事件冒泡，否则会弹出时间选择器
    this.spendDate = '';
    this.pageIndex = 1;        // 重置页数索引
    this.spendlist.length = 0; // 清空当前列表
    this.getSpendList();
  }

  // life cycle
  private mounted() {
    this.getSpendList();
    this.getBalance();
  }

}
